// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa77ffd1","668":"b0d0060b"}[chunkId] + ".chunk.js";
};